import Button, { type ButtonProps } from '@liquidweb-dev/undercurrent/Button';
import { useForm } from 'components/LWForm/LWForm';

export interface HookedSubmitProps extends ButtonProps {
	pristineDisabled?: boolean;
}

const HookedSubmit = ({
	disabled,
	/** if true, the submit button will be disabled if the form is not dirty */
	pristineDisabled,
	...rest
}: HookedSubmitProps) => {
	const { isValid, isDirty } = useForm();

	const isPristineDisabled = pristineDisabled && !isDirty.form;
	const shouldDisable = !isValid || disabled || isPristineDisabled;

	return <Button type="submit" disabled={shouldDisable} {...rest} />;
};

export default HookedSubmit;
